<template>
    <div class="accept-page">
        <div class="accept-card">
            <h2>{{ $t('team.set_password_title') }}</h2>
            <p v-if="preview.chain_name">{{ preview.chain_name }}</p>
            <p class="desc">{{ $t('team.set_password_desc') }}</p>
            <a-alert v-if="error_text" type="error" :message="error_text" show-icon style="margin-bottom: 16px;" />
            <a-form v-if="preview.valid">
                <a-form-item :label="$t('team.email')">
                    <a-input :value="preview.email" disabled />
                </a-form-item>
                <a-form-item :label="$t('team.name')">
                    <a-input v-model:value="name" />
                </a-form-item>
                <a-form-item :label="$t('team.new_password')">
                    <a-input v-model:value="password" type="password" />
                </a-form-item>
                <a-form-item :label="$t('team.confirm_password')">
                    <a-input v-model:value="confirm_password" type="password" />
                </a-form-item>
                <a-button type="primary" block :loading="saving" @click="submit">{{ $t('team.join') }}</a-button>
            </a-form>
        </div>
    </div>
</template>

<script>
    import md5 from 'md5';
    import { mapActions } from 'vuex';
    import { notification } from 'ant-design-vue';

    export default {
        name: 'TeamAcceptPage',
        data() {
            return {
                token: '',
                preview: {
                    valid: false,
                    expired: false,
                    email: '',
                    chain_name: '',
                },
                name: '',
                password: '',
                confirm_password: '',
                error_text: '',
                saving: false,
            };
        },
        created() {
            this.token = this.$route.query.token || '';
            this.loadPreview();
        },
        methods: {
            ...mapActions({
                previewInvite: 'team/previewInvite',
                acceptInvite: 'team/acceptInvite',
                applySession: 'login/apply_session',
            }),
            async loadPreview() {
                if (!this.token) {
                    this.error_text = this.$t('team.invalid_invite');
                    return;
                }
                try {
                    const res = await this.previewInvite({ token: this.token });
                    const data = (res && res.data) || {};
                    this.preview = {
                        valid: !!data.valid,
                        expired: !!data.expired,
                        email: data.email || '',
                        chain_name: data.chain_name || '',
                    };
                    if (data.expired) {
                        this.error_text = this.$t('team.expired_invite');
                    } else if (!data.valid) {
                        this.error_text = this.$t('team.invalid_invite');
                    }
                } catch (e) {
                    this.error_text = this.$t('team.invalid_invite');
                }
            },
            async submit() {
                const name = (this.name || '').trim();
                if (!name) {
                    notification.warning({ message: this.$t('team.name_required') });
                    return;
                }
                if (!this.password || this.password.length < 6 || this.password.length > 30) {
                    notification.warning({ message: this.$t('team.password_rule') });
                    return;
                }
                if (this.password !== this.confirm_password) {
                    notification.warning({ message: this.$t('team.password_mismatch') });
                    return;
                }
                this.saving = true;
                try {
                    const res = await this.acceptInvite({
                        token: this.token,
                        name,
                        pswd: md5(this.password),
                    });
                    if (res && res.code == 100000 && res.data && res.data.token) {
                        this.applySession(res.data);
                        this.$router.replace({ path: '/insight/home' });
                        return;
                    }
                    notification.warning({ message: (res && res.msg) || this.$t('team.invalid_invite') });
                } catch (e) {
                    notification.warning({ message: this.$t('team.invalid_invite') });
                }
                this.saving = false;
            },
        },
    };
</script>

<style scoped>
.accept-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    padding: 24px;
}
.accept-card {
    width: 420px;
    max-width: 100%;
    background: #fff;
    padding: 32px 28px;
    border-radius: 8px;
}
.desc {
    color: #666;
}
</style>
